import React from "react";
import { showWarningSnackbar } from "../../lib/components/Snackbar";
import { getCompanySettings } from "../../lib/util";
import { getMainPageContext } from "../../lib/util/MainPageContext";


export function validateCustomerCredit(parentType) {
    const enforceCredit = getCompanySettings().enforce_credit;
    if(enforceCredit && (enforceCredit === "L" || enforceCredit === "S")){
      const customerSettings = getMainPageContext().customer_settings;
      const creditStatus = customerSettings && customerSettings.credit_status;
      if(creditStatus && creditStatus === "D"){
        const contactName = getCompanySettings().order_contact_name || "us";
        const contactPhone = getCompanySettings().order_contact_phone;
        const contactEmail = getCompanySettings().ord_email_list;
        let messageBegin = "There is a problem with your account. We can accept your quote request, but we cannot accept your order. ";
        if(parentType.indexOf("order")  !== -1){
            messageBegin = "There is a problem with your account. We're unable to accept your order. ";
        }
        let messageEnd = "";
        if(contactPhone && contactEmail){
            messageEnd = "Please call "+contactName +" at "+contactPhone+" or email "+contactEmail+" for more information.";        
        }
        else if(contactPhone && !contactEmail){
            messageEnd ="Please call "+contactName +" at "+contactPhone+" for more information.";
        }
        else if(!contactPhone && contactEmail){
            messageEnd ="Please email"+contactEmail+" for more information.";
        }
        showWarningSnackbar(messageBegin + messageEnd, true);
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }